package org.hs_soft.runmynesto.data.api_datasource.product.tabs.tab_product_general


import com.varabyte.kobweb.browser.http.http
import kotlinx.browser.window

import kotlinx.coroutines.*
import kotlinx.serialization.json.Json
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.util.*
import kotlin.time.Duration.Companion.seconds
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_product_general.GetDataAssistantAnswerRepository

import org.hs_soft.runmynesto.domain.model.home.home.data_assistant_logs.DataAssistantLogsModel
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.Children


class
GetDataAssistantAnswerRepositoryImpl(
    private val requestManager: RequestManager
) : GetDataAssistantAnswerRepository {

    //private val abortController = requestManager.createController()

    override suspend fun getDataAssistantAnswer(
        assistant: String,
        email: String,
        question: String,
        userTimezoneOffsetMinutes: Int,
        userIdToken: String,
        cashList:List<Children>?,
        onLogAnswerUpdate: (DataAssistantLogsModel) -> Unit,
        language: String?,
        userName:String,
        userEmail:String,
        userCompanyName:String
    ): String {

        return withContext(Dispatchers.Default) {
            retry(times = 3, initialDelay = 2.seconds) {
                withTimeout(Constants.timeout.seconds) {
                    fetchAnswerWithLogs(
                        assistant,
                        email,
                        question,
                        userTimezoneOffsetMinutes,
                        userIdToken,
                        cashList,
                        onLogAnswerUpdate,
                        language,
                        userName,
                        userEmail,
                        userCompanyName
                    )
                }
            }
        }
    }

    suspend fun fetchAnswerWithLogs(
        assistant: String,
        email: String,
        question: String,
        userTimezoneOffsetMinutes: Int,
        userIdToken: String,
        cashList: List<Children>?,
        onLogAnswerUpdate: (DataAssistantLogsModel) -> Unit,
        language: String?,
        userName:String,
        userEmail:String,
        userCompanyName:String
    ): String = coroutineScope {
        fun generateUuid(): String =
            js("crypto.randomUUID()") as String

        val requestId = generateUuid()
        val pollingJob = launch {
            while (isActive) {
                delay(800)
                try {
                    val logs = fetchLog(requestId)
                    console.log(logs.answer, logs.message, logs.isGenerating)
                    onLogAnswerUpdate(logs)
                } catch (e: Exception) {
                    console.log("Logs Fetch Error: ${e.message}")
                    // You can add logging here
                }
            }
        }

        val answer = async {
            fetchAnswer(
                assistant, email, question, userTimezoneOffsetMinutes, userIdToken, cashList, requestId, language,
                userName,
                userEmail,
                userCompanyName
            )
        }

        val result = answer.await()
        pollingJob.cancelAndJoin()
        result
    }

    private suspend fun fetchLog(requestId: String): DataAssistantLogsModel {
        val abortController = requestManager.createController()
        val headers = mapOf(
            "Content-Type" to "application/json",
            "x-api-key" to ApiUtils.API_KEY.RESTAURANTS_API_KEY_VALUE,
        )

        val result = window.http.get(
            resource = ApiUtils.Domain.dataAssistantDomain +
                    ApiPath.getDataAssistantRequestLogMessage +
                    "?${ApiUtils.Field.request_id}=$requestId",
            headers = headers,
            abortController = abortController,
        ).decodeToString()

        val json = Json { ignoreUnknownKeys = true }

        return json.decodeFromString<DataAssistantLogsModel>(result)
    }

    private suspend fun fetchAnswer(
        assistant: String,
        email: String,
        question: String,
        userTimezoneOffsetMinutes: Int,
        userIdToken: String,
        cashList:List<Children>?,
        requestId: String,
        language: String?,
        userName:String,
        userEmail:String,
        userCompanyName:String
    ): String {
        val abortController = requestManager.createController()

        val headers = mapOf(
            "Content-Type" to "application/json",
            "x-api-key" to ApiUtils.API_KEY.RESTAURANTS_API_KEY_VALUE,
        )

        val result = window.http.post(
            resource = ApiUtils.Domain.dataAssistantDomain +
                    ApiPath.getDataAssistantAnswer +
                    "?${ApiUtils.Field.assistant}=$assistant" +
                    "&${ApiUtils.Field.question}=$question" +
                    "&${ApiUtils.Field.email}=$email" +
                    "&${ApiUtils.Field.userTimezoneOffsetMinutes}=$userTimezoneOffsetMinutes" +
                    "&${ApiUtils.Field.userIdToken}=$userIdToken" +
                    "&${ApiUtils.Field.request_id}=$requestId" +
                    "&${ApiUtils.Field.language}=$language" +
                    "&${ApiUtils.Field.user_name}=$userName" +
                    "&${ApiUtils.Field.user_email}=$userEmail" +
                    "&${ApiUtils.Field.user_company_name}=$userCompanyName",
            headers = headers,
            abortController = abortController,
        ).decodeToString()

        return result.parseData<String>()
    }


    private suspend fun <T> retry(
        times: Int,
        initialDelay: kotlin.time.Duration,
        factor: Double = 2.0,
        block: suspend () -> T
    ): T {
        var currentDelay = initialDelay
        repeat(times - 1) {
            try {
                return block()
            } catch (e: Exception) {
                // You can add logging here
            }
            delay(currentDelay)
            currentDelay *= factor
        }
        return block() // last attempt
    }
}




